import React from "react"
import Footer from "./footer"
import Header from "./header"
import NonHomeHeader from "./nonHomeHeader"
import { useMediaQuery } from "react-responsive"
import "../styles/index.scss"
import layoutStyles from "./layout.module.scss"

const Layout = ({ children, isHome }) => {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 961px)" })

  const homeLayout = (
    <div className={layoutStyles.page}>
      <Header isSmallScreen={isSmallScreen} />
      <div className={layoutStyles.container}>
        <div className={layoutStyles.content}>{children}</div>
      </div>
      <Footer />
    </div>
  )

  const nonHomeLayout = (
    <div className={layoutStyles.page}>
      <div className={layoutStyles.container}>
        <div className={layoutStyles.content}>
          <NonHomeHeader isSmallScreen={isSmallScreen} />
          {children}
        </div>
      </div>
      <Footer />
    </div>
  )

  return isHome ? homeLayout : nonHomeLayout
}

export default Layout
